enum MimeType {
  VIDEO_MP4 = 'video/mp4',
  VIDEO_QUICKTIME = 'video/quicktime',
  IMAGE_JPEG = 'image/jpeg',
  IMAGE_PNG = 'image/png',
  IMAGE_GIF = 'image/gif',
  AUDIO_MP3 = 'audio/mpeg',
  TEXT_HTML = 'text/html',
}

export default MimeType;
